module.exports = __webpack_public_path__ + "img/green_058.ead6bfde.png";